import SlideInfo from "./SlideInfo";

export default SlideInfo;